/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button, DropDown, Input } from "../../components";
import { NavLink, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UserDataObjType } from "../../utilities/types";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { GetStates } from "../../redux/Slice/Users/StateListSlice";
import { SignupUser } from "../../utilities/api/auth/auth-service";
import { toast } from "react-toastify";
import { messages } from "../../utilities/Messages";

const SignUp = () => {
  const { states } = useAppSelector((state) => state.states);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [submitButton, setSubmitButton] = useState(false);
  const getMessage = messages.auth;
  let schema = yup.object().shape({
    firstName: yup
      .string()
      .required(getMessage.firstName_isNotEmpty)
      .matches(
        /^[a-zA-Z .-]+$/,
        getMessage.firstName_matches
      )
      .min(3, getMessage.firstName_minLength)
      .max(30, getMessage.firstName_maxLength),
    lastName: yup
      .string()
      .required(getMessage.lastName_isNotEmpty)
      .matches(
        /^[a-zA-Z .-]+$/,
        getMessage.lastName_matches
      )
      .min(1, getMessage.lastName_minLength)
      .max(30, getMessage.lastName_maxLength),
    // gender: yup.string().required(getMessage.gender_isNotEmpty),
    gender: yup.string().notRequired(),
    phone: yup
      .string()
      .required(getMessage.phone_isNotEmpty)
      .matches(/^[0-9]\d{9}$/, getMessage.phone_matches),
    email: yup
      .string()
      .nullable()
      .required()
      .matches(/^[\w.]+@([\w-]+\.)+[\w-]{2,4}$/, getMessage.email_invalid_email)
      .max(70, getMessage.email_maxLength),


    addressLine1: yup
      .string()
      // .required(getMessage.addressLine1_isNotEmpty)
      .notRequired()
      .max(50, getMessage.addressLine1_maxLength),

    addressLine2: yup
      .string()
      .nullable()
      .notRequired()
      .max(50, getMessage.addressLine2_maxLength),
    landmark: yup
      .string()
      .nullable()
      .notRequired()
      .max(50, getMessage.landmark_maxLength),
    pincode: yup
      .string()
      // .required(getMessage.pincode_isNotEmpty)
      .notRequired(),
      // .matches(/^[1-9][0-9]{5}$/, getMessage.pincode_maxLength),
    city: yup
      .string()
      // .required(getMessage.city_isNotEmpty)
      .notRequired()
      .max(50, getMessage.city_maxLength),
    state: yup
      .string()
      // .required(getMessage.state_isNotEmpty)
      .notRequired()
      .max(50, getMessage.state_maxLength),
    password: yup
      .string()
      .required(getMessage.password_isNotEmpty)
      .matches(/^\S+$/, getMessage.password_matches)
      .min(8, getMessage.password_minLength)
      .max(15, getMessage.password_maxLength),
    cpassword: yup
      .string()
      .matches(/^\S+$/, getMessage.cpassword_matches)
      .oneOf([yup.ref("password")], getMessage.cpassword_oneof),
  });

  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm<UserDataObjType>({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    dispatch(GetStates());
    document.body.classList.add("signup-page");
    return () => {
      document.body.classList.remove("signup-page");
    };
  }, []);

  const onSubmit: SubmitHandler<any> = async (data) => {
    setSubmitButton(true);
    delete data.cpassword;
    let payload = {
      ...data,
      userType: "END_USER",
      addressLine2: "",
      country: "India",
      latitude: null,
      longitude: null,
    };

    let result = await SignupUser(payload);
    if (result.status === 200) {
      navigate("/verification", {
        state: {
          phone: data.phone,
          status: result.status,
          message: result.data.message,
          otpNumber: result.data.data.otpNumber,
          for: "signup",
        },
      });
    } else {
      toast.error(result.response.data.message);
    }
    setSubmitButton(false);
  };

  return (
    <>
      <Container>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <Row className="justify-content-center align-items-center bg-height">
            <Col lg={8}>
              <Card className="mt-5">
                <Card.Body>
                  <h3 className="card-title text-start">Sign Up</h3>
                  <Row>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="firstName" className="form-label">
                          First Name <small className="text-danger">*</small>
                        </label>
                        <Input
                          type="text"
                          placeholder="Enter First Name"
                          id="firstName"
                          name="firstName"
                          className="form-control"
                          register={register}
                          required
                        />
                        <small className="custom-error-msg">
                          {errors?.firstName?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="lastName" className="form-label">
                          Last Name <small className="text-danger">*</small>
                        </label>
                        <Input
                          type="text"
                          placeholder="Enter Last Name"
                          id="lastName"
                          name="lastName"
                          className="form-control"
                          register={register}
                          required
                        />
                        <small className="custom-error-msg">
                          {errors?.lastName?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="phone" className="form-label">
                          Mobile Number <small className="text-danger">*</small>
                        </label>
                        <Input
                          type="number"
                          placeholder="Enter Mobile Number"
                          id="phone"
                          name="phone"
                          className="form-control"
                          register={register}
                          required
                          onWheel={(e: any) => e.target.blur()}
                          onKeyDown={(e: any) =>
                            ["e", ".", "-", "+"].includes(e.key) &&
                            e.preventDefault()
                          }
                        />
                        <small className="custom-error-msg">
                          {errors?.phone?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="email" className="form-label">
                          Email <small className="text-danger">*</small>
                        </label>
                        <Input
                          type="text"
                          placeholder="Enter Email Address"
                          id="email"
                          name="email"
                          className="form-control"
                          register={register}
                        />
                        <small className="custom-error-msg">
                          {errors?.email?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="gender" className="form-label">
                          Gender
                          {/* <small className="text-danger">*</small> */}
                        </label>
                        <DropDown
                          name="gender"
                          id="gender"
                          className="form-control"
                          register={register}
                          // required
                        >
                          <option value="">Select Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="other">Other</option>
                        </DropDown>
                        <small className="custom-error-msg">
                          {errors?.gender?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="password" className="form-label">
                          Password <small className="text-danger">*</small>
                        </label>
                        <Input
                          type="password"
                          placeholder="Password"
                          id="password"
                          name="password"
                          className="form-control"
                          register={register}
                          required
                        />
                        <small className="custom-error-msg">
                          {errors?.password?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="cpassword" className="form-label">
                          Confirm Password{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <Input
                          type="password"
                          placeholder="Confirm Password"
                          id="cpassword"
                          name="cpassword"
                          className="form-control"
                          register={register}
                        />
                        <small className="custom-error-msg">
                          {errors?.cpassword?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="addressLine1" className="form-label">
                          Address Line 1
                          {/* <small className="text-danger">*</small> */}
                        </label>
                        <Input
                          type="text"
                          placeholder="Enter Address"
                          id="addressLine1"
                          name="addressLine1"
                          className="form-control"
                          register={register}
                          // required
                        />
                        <small className="custom-error-msg">
                          {errors?.addressLine1?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="addressLine2" className="form-label">
                          Address Line 2
                        </label>
                        <Input
                          type="text"
                          placeholder="Enter Address Line 2"
                          id="addressLine2"
                          name="addressLine2"
                          className="form-control"
                          register={register}
                          // required
                        />
                        <small className="custom-error-msg">
                          {errors?.addressLine2?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="landmark" className="form-label">
                          Landmark
                        </label>
                        <Input
                          type="text"
                          placeholder="Enter landmark"
                          id="landmark"
                          name="landmark"
                          className="form-control"
                          register={register}
                          // required
                        />
                        <small className="custom-error-msg">
                          {errors?.landmark?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="pincode" className="form-label">
                          Pincode
                          {/* <small className="text-danger">*</small> */}
                        </label>
                        <Input
                          type="number"
                          placeholder="Enter pincode"
                          id="pincode"
                          name="pincode"
                          className="form-control"
                          register={register}
                          // required
                          onWheel={(e: any) => e.target.blur()}
                          onKeyDown={(e: any) =>
                            ["e", ".", "-", "+"].includes(e.key) &&
                            e.preventDefault()
                          }
                        />
                        <small className="custom-error-msg">
                          {errors?.pincode?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="city" className="form-label">
                          City
                          {/* <small className="text-danger">*</small> */}
                        </label>
                        <Input
                          type="text"
                          placeholder="Enter City"
                          id="city"
                          name="city"
                          className="form-control"
                          register={register}
                          // required
                        />
                        <small className="custom-error-msg">
                          {errors?.city?.message}
                        </small>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mb-3 text-start">
                        <label htmlFor="state" className="form-label">
                          State
                          {/* <small className="text-danger">*</small> */}
                        </label>
                        <DropDown
                          name="state"
                          id="booking-state"
                          className="form-control"
                          register={register}
                          // required
                        >
                          <option value="">Select State</option>
                          {states?.map((item: any) => {
                            return (
                              <option key={item.code} value={item.name}>
                                {item.name}
                              </option>
                            );
                          })}
                        </DropDown>
                        <small className="custom-error-msg">
                          {errors?.state?.message}
                        </small>
                      </div>
                    </Col>
                  </Row>
                  <Row className="align-items-center">
                    <Col lg={6} className="text-start">
                      <p>
                        Already have an account?{" "}
                        <NavLink to="/login-page">Login</NavLink>
                      </p>
                    </Col>
                    <Col lg={6} className="text-end">
                      <Button
                        disabled={submitButton}
                        type="submit"
                        bname={submitButton ? "Submitting" : "Signup"}
                        name="signup"
                        id="signup"
                        className="btn btn-primary rounded-1"
                      ></Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </form>
      </Container>
    </>
  );
};
export { SignUp };
